(function($) {
  'use strict';

  /***
  * CUSTOM VALIDATION PATTERNS
  */
  Foundation.Abide.defaults.patterns.bic = /([a-zA-Z]{4}[a-zA-Z]{2}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?)/;
  Foundation.Abide.defaults.patterns.iban = /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;

  /* END CUSTOM VALIDATION PATTERNS */

  /***
  * CUSTOM VALIDATORS
  */
  Foundation.Abide.defaults.validators.max_amount =
  function($el,required,parent) {
    // parameter 1 is jQuery selector
    if (!required) return true;
    var max = parseInt(1000),
        min = parseInt(5),
        amount = parseInt($el.val());

    if(!isNaN(amount)){
      $('label[for="betrag"]').removeClass('is-invalid-label');
      if(amount > max || amount < min){
        $('label[for="betrag"]').addClass('is-invalid-label');
        parent.find('.form-error').text('Der Betrag muss zwischen 5 und 1000 Euro liegen.');
        return false;
      }
    }else{
      parent.find('.form-error').text('Dies ist ein Pflichtfeld.');
      $('label[for="betrag"]').addClass('is-invalid-label');
      return false;
    }


  };

  /* END CUSTOM VALIDATORS */

  /***
  * CUSTOM ERROR TEXT
  */
  $('input[name="sepa_data[bic]"]').on("invalid.zf.abide", function(ev,el) {
    if(el.val() !== ""){
      el.next('.form-error').text('Dies ist keine gültige BIC.');
    }else{
      el.next('.form-error').text('Dies ist ein Pflichtfeld.');
    }
  });

  $('input[name="sepa_data[iban]"]').on("invalid.zf.abide", function(ev,el) {
    if(el.val() !== ""){
      el.next('.form-error').text('Dies ist keine gültige IBAN.');
    }else{
      el.next('.form-error').text('Dies ist ein Pflichtfeld.');
    }
  });

  $('input[name="email"]').on("invalid.zf.abide", function(ev,el) {
    if(el.val() !== ""){
      el.next('.form-error').text('Dies ist keine gültige E-Mail-Adresse.');
    }else{
      el.next('.form-error').text('Dies ist ein Pflichtfeld.');
    }
  });

  /* END CUSTOM ERROR TEXT */

  // Fire on document ready.
  $( document ).ready( function() {

  });

})( jQuery );
